import { useFormikContext } from "formik";

import ContractWorkforce from "../../TempInviteAgency/ContractWorkforce";
import PermanentPlacement from "../../TempInviteAgency/PermanentPlacement";
import PlacementTypeSelection from "../../TempInviteAgency/PlacementTypeSelection";

function AddAsLegacyModalContent({ currentOrganization }) {
  const { values } = useFormikContext();

  return (
    <>
      <div style={{ paddingBottom: 8 }}>
        As a preferred agency you will be able to control which JobCasts this
        agency receives. After they are invited their team will show up in
        Agency Selection when creating a JobCast.
      </div>
      {currentOrganization.contractActivated && <PlacementTypeSelection />}
      {values.placementTypes?.perm && <PermanentPlacement />}
      {currentOrganization.contractActivated &&
        values.placementTypes?.temp && <ContractWorkforce />}
    </>
  );
}

export default AddAsLegacyModalContent;
